import React, { useState, useEffect } from "react";
import transferAPI from "../../API/transferAPI";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const VND = new Intl.NumberFormat("vi-VN", {
  style: "currency",
  currency: "VND",
});

function HistoryTrans() {
  const [historyTrans, sethistoryTrans] = useState([]);

  useEffect(() => {
    try {
      const fetchGetHistoryWithdraw = async () => {
        const result = await transferAPI.getHistoryTrans();
        // console.log(result);

        if (result.status === true) {
          sethistoryTrans(result.data);
        } else {
          toast.error(result.msg, { theme: "light" });
        }
      };

      fetchGetHistoryWithdraw();
    } catch (error) {
      return toast.error("Có lỗi xảy ra!", { theme: "light" });
    }
  }, []);

  return (
    <div>
      {historyTrans.length > 0 ? (
        <table className="table table-bordered rounded table-hover">
          <thead className="text-center" style={{ backgroundColor: "#e8f0fc" }}>
            <th>Thời gian</th>
            <th>Số giao dịch</th>
            <th>Số tiền nhận thực tế</th>
            <th>Chuyển ra</th>
            <th>Chuyển vào</th>
            <th>Trạng thái</th>
          </thead>
          <tbody>
            {historyTrans.map((item, i) => {
              return (
                <tr key={i} className="text-center">
                  <td>{item.today}</td>
                  <td>{item.id}</td>
                  <td>{VND.format(item.money)}</td>
                  <td>
                    {item.type == 1
                      ? "Tài khoản người dùng"
                      : item.providercode}
                  </td>
                  <td>
                    {item.type == 0
                      ? "Tài khoản người dùng"
                      : item.providercode}
                  </td>
                  <td>{item.status == 0 ? "Thành công" : "Thất bại"}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      ) : (
        <>
          <table className="table table-bordered rounded">
            <thead
              className="text-center"
              style={{ backgroundColor: "#e8f0fc" }}
            >
              <th>Thời gian</th>
              <th>Số giao dịch</th>
              <th>Số tiền nhận thực tế</th>
              <th>Chuyển ra</th>
              <th>Chuyển vào</th>
              <th>Trạng thái</th>
            </thead>
          </table>
          <span className="d-flex align-items-center justify-content-center py-2">
            Không có dữ liệu
          </span>
        </>
      )}

      <ToastContainer
        position="top-right"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
}

export default HistoryTrans;
